import { trackChangeBillDateAuthorizePurchase } from '../../../helpers/changeBillingDate/analytics';
import { PAYMENT_ERROR_GROUPS, PAYMENT_ERROR_TYPES } from '../constants/paymentErrors';
import { PAYMENT_STAGES } from '../PaymentContextProvider';
import { BILLING_DATE_CHANGED } from '../../../actions/billing/changeBillingDate';
import changeBillDateMethod from '../helpers/changeBillingDate';

/*
  Responsible for completing the 3DS authorization for billing date change.
  Called after user completes the 3DS challenge.
  Takes the authorization output token and finalizes the billing date change.
*/

const handleChangeBillingDateFailure = (paymentContext, errorMessage) => {
  const { raisePaymentError, goToPaymentStage } = paymentContext;
  trackChangeBillDateAuthorizePurchase(false);
  raisePaymentError({
    message: errorMessage || 'Failed to complete billing date change',
    group: PAYMENT_ERROR_GROUPS.AUTHORIZATION,
    type: PAYMENT_ERROR_TYPES.AUTHORIZATION.UNSUCCESSFUL_3DS,
  });
  goToPaymentStage(PAYMENT_STAGES.CHANGE_BILLING_DATE_FAILURE);
};

const changeBillingAuthorizedTransition =
  (paymentContext, authorizationOutputToken, selectedBillDate) => async dispatch => {
    const { addPaymentToken, tokens, goToPaymentStage } = paymentContext;

    // Store the authorization output token
    addPaymentToken({ authorizationOutput: authorizationOutputToken });

    const purchasePayload = {
      selectedBillDate,
      paymentAuthorizationResult: authorizationOutputToken,
      ...(tokens?.paymentMethodToken ? { paymentMethodToken: tokens.paymentMethodToken } : {}),
    };

    try {
      goToPaymentStage(PAYMENT_STAGES.CHANGE_BILLING_DATE_PROCESSING);
      const changeResult = await dispatch(changeBillDateMethod(purchasePayload));
      const { complete } = changeResult || {};

      if (complete) {
        trackChangeBillDateAuthorizePurchase(true);
        if (changeResult?.data) {
          dispatch({ type: BILLING_DATE_CHANGED, payload: changeResult.data });
        }
        goToPaymentStage(PAYMENT_STAGES.CHANGE_BILLING_DATE_SUCCESS);
      } else {
        handleChangeBillingDateFailure(paymentContext);
      }
    } catch (error) {
      handleChangeBillingDateFailure(paymentContext, error.message);
    }
  };

export default changeBillingAuthorizedTransition;
